import { render, staticRenderFns } from "./_import.vue?vue&type=template&id=8c66265c&scoped=true&"
import script from "./_import.vue?vue&type=script&lang=js&"
export * from "./_import.vue?vue&type=script&lang=js&"
import style0 from "./_import.vue?vue&type=style&index=0&id=8c66265c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c66265c",
  null
  
)

export default component.exports